// extracted by mini-css-extract-plugin
module.exports = {"dialogContentWrapper":"DialogEditItem_dialogContentWrapper__2x_eI"};